export interface SettingSection {
  id: string;
  title: string;
  icon: string;
  items: { label: string; value: string; type: string; description?: string }[];
}

export const settingSections: SettingSection[] = [
  {
    id: "llm",
    title: "大模型服务",
    icon: "ri-brain-line",
    items: [
      { label: "API Key", value: "sk-****a3f2", type: "password", description: "OpenAI / 文心一言 API 密钥" },
      { label: "模型版本", value: "gpt-4o", type: "select", description: "AI 问答使用的模型" },
      { label: "最大 token", value: "4096", type: "number", description: "单次问答最大 token 数" },
      { label: "温度", value: "0.7", type: "number", description: "模型生成温度参数" },
    ],
  },
  {
    id: "tts",
    title: "语音合成服务",
    icon: "ri-mic-line",
    items: [
      { label: "API Key", value: "ak-****b8e1", type: "password", description: "TTS 服务访问密钥" },
      { label: "默认音色", value: "鲟侠船长", type: "select", description: "默认讲解音色" },
      { label: "语速", value: "1.0", type: "number", description: "语音合成语速" },
      { label: "音量", value: "1.0", type: "number", description: "语音合成音量" },
    ],
  },
  {
    id: "faceswap",
    title: "即梦换脸服务",
    icon: "ri-image-edit-line",
    items: [
      { label: "Access Key", value: "ak-****c5d3", type: "password", description: "火山引擎即梦换脸 AK" },
      { label: "Secret Key", value: "sk-****f7a2", type: "password", description: "火山引擎即梦换脸 SK" },
      { label: "模板审核", value: "开启", type: "toggle", description: "上传模板是否需要人工审核" },
      { label: "内容安全", value: "严格", type: "select", description: "换脸内容安全策略级别" },
      { label: "人像留存期", value: "7", type: "number", description: "用户上传照片保留天数" },
    ],
  },
  {
    id: "oss",
    title: "存储服务",
    icon: "ri-database-2-line",
    items: [
      { label: "存储类型", value: "阿里云 OSS", type: "select", description: "对象存储服务商" },
      { label: "Bucket", value: "three-gorges-prod", type: "text", description: "存储空间名称" },
      { label: "CDN 加速", value: "开启", type: "toggle", description: "是否启用 CDN 加速" },
      { label: "图片压缩", value: "开启", type: "toggle", description: "上传图片自动压缩" },
    ],
  },
  {
    id: "tenant",
    title: "租户隔离",
    icon: "ri-building-line",
    items: [
      { label: "租户模式", value: "多租户", type: "select", description: "系统租户模式" },
      { label: "数据隔离", value: "开启", type: "toggle", description: "租户间数据完全隔离" },
      { label: "资源配额", value: "默认", type: "select", description: "默认租户资源配额" },
    ],
  },
  {
    id: "auth",
    title: "注册与权限",
    icon: "ri-shield-user-line",
    items: [
      { label: "注册方式", value: "邀请码", type: "select", description: "新用户注册方式" },
      { label: "默认角色", value: "运营人员", type: "select", description: "新用户默认角色" },
      { label: "登录有效期", value: "24", type: "number", description: "登录会话有效期（小时）" },
      { label: "双因素认证", value: "关闭", type: "toggle", description: "管理员是否强制 2FA" },
    ],
  },
  {
    id: "language",
    title: "语言与时区",
    icon: "ri-global-line",
    items: [
      { label: "默认语言", value: "中文", type: "select", description: "系统默认语言" },
      { label: "支持语言", value: "中/英/日/韩/德/西/法/葡/意/俄", type: "text", description: "后端 qwen3-tts 支持的 10 种带语音语言（另支持阿拉伯语文本）" },
      { label: "时区", value: "Asia/Shanghai", type: "select", description: "系统默认时区" },
      { label: "日期格式", value: "YYYY-MM-DD", type: "select", description: "日期显示格式" },
    ],
  },
  {
    id: "reportSchedule",
    title: "运维报告定时任务",
    icon: "ri-timer-line",
    items: [
      { label: "自动生成", value: "开启", type: "toggle", description: "是否启用运维报告定时自动生成" },
      { label: "日报生成时间", value: "18:00", type: "text", description: "每日自动生成日报的时间" },
      { label: "周报生成日", value: "周日", type: "select", description: "每周生成周报的日期" },
      { label: "周报生成时间", value: "20:00", type: "text", description: "每周自动生成周报的时间" },
      { label: "月报生成日", value: "1日", type: "select", description: "每月生成月报的日期" },
      { label: "月报生成时间", value: "10:00", type: "text", description: "每月自动生成月报的时间" },
      { label: "事件报告生成", value: "自动", type: "select", description: "事件触发时是否自动生成报告" },
      { label: "归档周期（天）", value: "90", type: "number", description: "历史报告超过此天数自动归档" },
    ],
  },
];